import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/MyBoard/activities/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_LAST_LOADED_ID = NAMESPACE + 'SET_LAST_LOADED_ID'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'

const initialState = {
  activities: [],
  activitiesById: {},
  lastLoadedId: null,
  isLoading: false,
  isLoaded: false
}

const elementDefaults = {

}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...initialState
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case SET_LAST_LOADED_ID:
      return {
        ...state,
        lastLoadedId: action.payload.lastLoadedId
      }
    case ADD:
      return {
        ...state,
        activities: addUniqueValueToArray({
          array: state.activities,
          value: action.payload.id,
          index: action.payload.index
        }),
        activitiesById: {
          ...state.activitiesById,
          [action.payload.id]: {
            ...elementDefaults,
            ...action.payload
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        activities: [ ...state.activities ],
        activitiesById: { ...state.activitiesById }
      }
      action.payload.forEach(message => {
        newState.activities = addUniqueValueToArray({
          array: newState.activities,
          value: message.id,
          index: message.index
        })
        newState.activitiesById[message.id] = {
          ...elementDefaults,
          ...message
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        activities: [ ...state.activities.filter(id => id !== action.payload.id) ],
        activitiesById: { ...state.activitiesById }
      }
      delete newState.activitiesById[action.payload.id]
      return newState
    }
    case SET_NAME:
      return state.activitiesById[action.payload.id] ? {
        ...state,
        activitiesById: {
          ...state.activitiesById,
          [action.payload.id]: {
            ...state.activitiesById[action.payload.id],
            name: action.payload.name
          }
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function setLastLoadedId ({ lastLoadedId }) {
  return {
    type: SET_LAST_LOADED_ID,
    payload: {
      lastLoadedId
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (elementsArray) {
  return {
    type: ADD_ARRAY,
    payload: elementsArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setName ({ id, name }) {
  return {
    type: SET_NAME,
    payload: {
      id,
      name
    }
  }
}
